import React from "react";

import PropTypes from "prop-types";

import { CarrierLogo } from "Cobalt/CarrierLogo";
import CommonHeader from "Cobalt/Header";

import StartApplicationButton from "./header/StartApplicationButton";

import makeBem from "Utils/makeBem";

const bem = makeBem("PlanDetails");

export default function Header({ plan, inCart, role, shopMode }) {
  const planName = (
    <CommonHeader className={bem("PlanName")} level={7} title={plan.raw_name} id={`plan-name-${plan.id}`} ml={4} mr={6}>
      {plan.full_display_name}
    </CommonHeader>
  );

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <CarrierLogo plan={plan} maxSize={3} />
      <div>{planName}</div>
      <div>{!inCart && role !== "enrolled" && shopMode !== "plan_suite" && <StartApplicationButton plan={plan} />}</div>
    </div>
  );
}

Header.propTypes = {
  plan: PropTypes.shape({
    carrier_logo: PropTypes.string,
    carrier: PropTypes.string,
    raw_name: PropTypes.string,
    display_name: PropTypes.string,
    plan_type: PropTypes.string,
    deductible: PropTypes.number,
    id: PropTypes.string,
    estimated_costs: PropTypes.shape({
      pcp_visit: PropTypes.number,
      hospitalization: PropTypes.number,
      generic_drugs: PropTypes.number,
    }),
  }),
};
